LS.validate = {
	/**
	 * Validate data store against ruleset
	 *
	 * @param {Object} data
	 * @param {Object} rules
	 * @param {Object} [options]
	 * @returns {Array|Boolean}
	 */
	run(data, rules, options) {
		const conf = Object.assign({
			firstOnly: true,
			flash: true,
			labels: {}
		}, options);
		const names = Object.keys(rules);
		const errors = [];

		for (let i = 0; i < names.length; i++) {
			const key = names[i];
			const name = key;
			const checks = $.toArray(rules[key]);
			const value = data[key];

			let required = checks.indexOf('required');

			if (required > -1) {
				if (required > 0) {
					checks.splice(required, 1);
					checks.unshift('required');
				}

				required = true;
			} else {
				required = false;
			}

			for (let x = 0; x < checks.length; x++) {
				if (! required && ! value) {
					break;
				}

				const parts = checks[x].split(/:(.+)/);
				const fn = this.validators[parts[0].replace('data-', '')];
				const param = parts.length > 1 ?
					parts[1] : '';

				if (fn.valid.call(data, value, key, param)) {
					continue;
				}

				errors.push(key);

				if (conf.flash) {
					LS.util.warn($.view.render(fn.msg, {
						attribute: LS.util.capitalize(
							conf.labels[name] || name.replace('_', ' ')
						),
						param: param
					}));
				}

				if (conf.callback) {
					conf.callback(key);
				}

				if (conf.firstOnly) {
					return errors;
				}
			}
		}

		return errors.length ?
			errors : true;
	},

	/**
	 * Highlight form element
	 *
	 * @param {$} el
	 * @param {Boolean} [focus=false]
	 */
	highlight(el, focus) {
		try {
			const $el = $(el);
			const invalidClass = '-is-invalid';

			let $target = $el;

			if ($el[0].nodeName === 'SELECT') {
				$target = $el.parent();
			}

			$target.addClass(invalidClass);

			if (focus) {
				$el.focus(true);
			} else {
				LS.util.setScroll($target, true, 50);
			}

			setTimeout(() => {
				$target.removeClass(invalidClass);
			}, 2000);
		} catch (e) {
			//
		}
	},

	/**
	 * Verify pattern
	 *
	 * @param {String} value
	 * @param {String} pattern
	 * @param {Boolean} [exact=false]
	 * @returns {Boolean}
	 */
	verify(value, pattern, exact) {
		pattern = this.patterns[pattern];

		if (exact) {
			pattern = '^' + pattern + '$';
		} else {
			pattern = '\\b' + pattern + '\\b';
		}

		return new RegExp(pattern, 'i').test(value.trim());
	},

	/**
	 * Verify email
	 *
	 * @param {String} value
	 */
	isEmail(value) {
		return this.verify(value, 'email', true);
	},

	/**
	 * Check if value contain email
	 *
	 * @param {String} value
	 */
	hasEmail(value) {
		return this.verify(value, 'email');
	},

	/**
	 * Verify URL
	 *
	 * @param {String} value
	 */
	isUrl(value) {
		return this.verify(value, 'url', true);
	},

	/**
	 * Check if value contain URL
	 *
	 * @param {String} value
	 */
	hasUrl(value) {
		return this.verify(value, 'url');
	},

	/**
	 * Verify phone
	 *
	 * @param {String} value
	 */
	isPhone(value) {
		return /^([()+\d \-\/x*#,.]|ext\.?)+$/i.test(value) &&
			value.replace(/\D/g, '').length >= 10;
	},

	/**
	 * Check if value contains phone
	 *
	 * @param {String} value
	 */
	hasPhone(value) {
		return this.verify(value, 'phone');
	},

	/**
	 * Verify mixed case
	 *
	 * @param {String} value
	 */
	isMixedCase(value) {
		return /[a-z]/.test(value) &&
			(/[A-Z]/.test(value) || /^\d/.test(value.trim()));
	},

	patterns: {
		email: '[^ ]+@[a-z\\d\\-]+(\\.[a-z]{2,})+',
		phone: '\\d{3}([ .-]|\\) ?)\\d{3}[ .-]?\\d{4}',
		url: '(https?:\\/\\/|www\\.)([a-z\\d\\-.]+)\\.[a-z]{2,}.*'
	},

	validators: {
		required: {
			msg: '{{ attribute }} field is required',
			valid: value => ! (
				value === null ||
				value === undefined ||
				(typeof value === 'string' && value.trim() === '') ||
				(typeof value === 'object' && ! Object.keys(value).length)
			)
		},
		numeric: {
			msg: '{{ attribute }} must be a number',
			valid: value => ! isNaN(parseFloat(value)) && isFinite(value)
		},
		email: {
			msg: '{{ attribute }} must be valid',
			valid: value => LS.validate.isEmail(value)
		},
		tel: {
			msg: '{{ attribute }} must be valid',
			valid: value => LS.validate.isPhone(value)
		},
		url: {
			msg: '{{ attribute }} must be a valid URL',
			valid: value => LS.validate.isUrl(value)
		},
		json: {
			msg: '{{ attribute }} must be valid JSON',
			valid: (value, key) => {
				try {
					this[key] = JSON.parse(value);
				} catch (e) {
					return false;
				}

				return true;
			}
		},
		min: {
			msg: '{{ attribute }} must be {{ param }} or more',
			valid: (value, key, param) => LS.util.parseNumber(value) >= Number(param)
		},
		max: {
			msg: '{{ attribute }} must be {{ param }} or less',
			valid: (value, key, param) => LS.util.parseNumber(value) <= Number(param)
		},
		minlength: {
			msg: '{{ attribute }} must contain at least {{ param }} characters',
			valid: (value, key, param) => value.length >= Number(param)
		},
		maxlength: {
			msg: '{{ attribute }} must contain at most {{ param }} characters',
			valid: (value, key, param) => value.length <= Number(param)
		},
		pattern: {
			msg: '{{ attribute }} is invalid',
			valid: (value, key, param) => {
				if (! value.trim()) {
					return true;
				}

				return (new RegExp('^' + param + '$')).test(value);
			}
		},
		case: {
			msg: '{{ attribute }} must be "{{ param|capitalize }} {{ param|is("title") ? "C" : "c" }}ase"',
			valid: value => LS.validate.isMixedCase(value)
		}
	}
};